/*
 * SPDX-FileCopyrightText: 2025 Zextras <https://www.zextras.com>
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
export const SETTINGS_OUT_OF_OFFICE_TEXT_AREA_MAX_CHAR_LIMIT = 8192;
export const LOCAL_STORAGE_ENABLE_STRICT_MODE = 'enable_strict_mode';
